import { createFileRoute } from "@tanstack/react-router";
import { FeedbackPage } from "@/pages/Feedback";

export const Route = createFileRoute("/feedback")({
  component: FeedbackPage,
});
